import { render, staticRenderFns } from "./NoticeConfig.vue?vue&type=template&id=5bf50899&scoped=true"
import script from "./NoticeConfig.vue?vue&type=script&lang=ts"
export * from "./NoticeConfig.vue?vue&type=script&lang=ts"
import style0 from "./NoticeConfig.vue?vue&type=style&index=0&id=5bf50899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf50899",
  null
  
)

export default component.exports